import {
  GET_TRIGGER_ORDER_QUOTE,
  GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  GET_TRIGGER_ORDER_QUOTE_ERROR,
  EXECUTE_TRIGGER_ORDER_QUOTE,
  EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
} from './triggerOrdersActionConstants';

export const getTriggerOrderQuote = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE,
  payload,
});

export const getTriggerOrderQuoteSuccess = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  payload,
});

export const getTriggerOrderQuoteError = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE_ERROR,
  payload,
});

export const executeTriggerOrderQuote = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE,
  payload,
});

export const executeTriggerOrderQuoteSuccess = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  payload,
});

export const executeTriggerOrderQuoteError = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
  payload,
});
